export const documents = (state) => {
  return state.documents.data || []
}
export const documentsLoading = (state) => {
  return state.documents.loading
}
export const documentsLastUpdate = (state) => {
  return state.documents.lastUpdate
}

export const documentsByClient = (state) => (idCliente) => {
  if (idCliente === undefined || idCliente === null) return []
  if (!state || !state.documentsByClient) return []
  const key = String(idCliente)
  return state.documentsByClient.data[key] || []
}
export const documentsByClientLoading = (state) => (idCliente) => {
  if (idCliente === undefined || idCliente === null) return false
  if (!state || !state.documentsByClient) return false
  const key = String(idCliente)
  return Boolean(state.documentsByClient.loading[key])
}
export const documentsByClientLastUpdate = (state) => (idCliente) => {
  if (idCliente === undefined || idCliente === null) return null
  if (!state || !state.documentsByClient) return null
  const key = String(idCliente)
  return state.documentsByClient.lastUpdate[key] || null
}

export const templates = (state) => {
  return state.templates.data || []
}
export const templatesLoading = (state) => {
  return state.templates.loading
}
export const templatesLastUpdate = (state) => {
  return state.templates.lastUpdate
}

export const signers = (state) => {
  return state.signers.data || []
}
export const signersFiltered = (state) => {
  return state.signers.dataFiltered || []
}
export const signersLoading = (state) => {
  return state.signers.loading
}
export const signersLastUpdate = (state) => {
  return state.signers.lastUpdate
}

export const variables = (state) => {
  return state.variables.data || []
}
export const variablesLoading = (state) => {
  return state.variables.loading
}
export const variablesLastUpdate = (state) => {
  return state.variables.lastUpdate
}

export const roles = (state) => {
  return state.roles.data || []
}
export const rolesMap = (state) => {
  return state.roles.data.reduce((all, next) => {
    all[next.role] = next.name
    return all
  }, {})
}
export const rolesLoading = (state) => {
  return state.roles.loading
}
export const rolesLastUpdate = (state) => {
  return state.roles.lastUpdate
}

export const systemVariables = (state) => {
  return state.systemVariables.data || []
}
export const systemVariablesLoading = (state) => {
  return state.systemVariables.loading
}
export const systemVariablesLastUpdate = (state) => {
  return state.systemVariables.lastUpdate
}

export const variablesOptions = (state) => {
  return state.variablesOptions.data || {}
}
export const variablesOptionsLoading = (state) => {
  return state.variablesOptions.loading
}
export const variablesOptionsLastUpdate = (state) => {
  return state.variablesOptions.lastUpdate
}
